import pino from 'pino'

const logger = pino({
  level: import.meta.env.VITE_LOG_LEVEL || 'debug',
  timestamp: pino.stdTimeFunctions.isoTime
})

export default logger
